import React from 'react';
import styles from './index.module.scss';

export default function Screen3() {
  return (
    <section className={styles['screen3-cover']}>
      <div className={styles['screen3-wrap']}>
        {/* 主标题 */}
        <h2 className={styles['screen3-title']}>
          专属级的个性化学习
        </h2>
        
        {/* 副标题 */}
        <div className={styles['screen3-subtitle']}>
          尊重每一位学习者“个体”，构建专属的个性化学习链路
        </div>

        {/* 三个功能特性 - 水平布局 */}
        <div className={styles['screen3-features']}>
          {/* 特性1：精细测定,多维能力 */}
          <div className={styles['screen3-feature-card']}>
            <div className={styles['screen3-icon-container']}>
              <div className={`${styles['screen3-icon']} ${styles['screen3-icon-1']}`}></div>
            </div>
            <h3 className={styles['screen3-feature-title']}>精细测定，多维能力</h3>
            <p className={styles['screen3-feature-desc']}>
              基于专业大纲和个人学情等多维测定手段，即时调整教授策略，精准学习薄弱知识
            </p>
          </div>

          {/* 连接线1 */}
          <div className={styles['screen3-connector']}>
            <div className={styles['screen3-line']}></div>
          </div>

          {/* 特性2：分步引导,智能讲授 */}
          <div className={styles['screen3-feature-card']}>
            <div className={styles['screen3-icon-container']}>
              <div className={`${styles['screen3-icon']} ${styles['screen3-icon-2']}`}></div>
            </div>
            <h3 className={styles['screen3-feature-title']}>分步引导，智能讲授</h3>
            <p className={styles['screen3-feature-desc']}>
              自研数字人结合爱学大模型，实现AI一对一导师对问题针对性地分步耐心讲解
            </p>
          </div>

          {/* 连接线2 */}
          <div className={styles['screen3-connector']}>
            <div className={styles['screen3-line']}></div>
          </div>

          {/* 特性3：及时回顾,完全掌握 */}
          <div className={styles['screen3-feature-card']}>
            <div className={styles['screen3-icon-container']}>
              <div className={`${styles['screen3-icon']} ${styles['screen3-icon-3']}`}></div>
            </div>
            <h3 className={styles['screen3-feature-title']}>及时回顾，完全掌握</h3>
            <p className={styles['screen3-feature-desc']}>
              通过学习报告及时回顾学习情况，对知识点掌握和学习互动进行直观展示，原汁原味复现学习现场
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
